import { Accordion, AccordionContent } from '@/components/AccordionSideMenu';
import {
  BackButton,
  DataList,
  Item,
} from '@/components/NewHeader/SideMenu/helperComponents';
import { useSideMenu } from '@/components/NewHeader/SideMenu/useSideMenu';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';
import { usePromotionalCatalogs } from '@/hooks/usePromotionalCatalogs';
import { useEffect, useState } from 'react';

export function Offers() {
  const {
    newHeader: { nav, search },
  } = useTranslation();
  const { sicily, puglia } = usePromotionalCatalogs();
  const { close } = useSideMenu();
  const { sendMenuClickEvent } = useGTMEvents();

  const section = nav.find((item) => item.id === 'offers')?.title || 'Offers';
  const sections = [
    { title: search.regions.sicily, items: sicily },
    { title: search.regions.puglia, items: puglia },
  ].filter((sectionItem) => sectionItem.items.length > 0);
  const [value, setValue] = useState('');

  useEffect(() => {
    const availableTitles = [
      sicily.length ? search.regions.sicily : null,
      puglia.length ? search.regions.puglia : null,
    ].filter((title): title is string => Boolean(title));

    if (!availableTitles.length) {
      return;
    }

    if (!availableTitles.includes(value)) {
      setValue(availableTitles[0]);
    }
  }, [sicily.length, puglia.length, search.regions.sicily, search.regions.puglia, value]);

  const handleItemClick = (item: { title: string; href: string }) => {
    sendMenuClickEvent({ section, sectionItem: item.title });
    close();
  };

  return (
    <>
      <BackButton />

      <Accordion
        type="single"
        collapsible
        className="w-full"
        value={value}
        onValueChange={setValue}>
        {sections.map((sectionItem) => (
          <Item
            key={sectionItem.title}
            value={sectionItem.title}
            isOpen={value === sectionItem.title}>
            <AccordionContent className="border-b border-primary/20 bg-primary/5 px-4 py-4 text-primary">
              <DataList
                scrollable
                onItemClick={handleItemClick}
                data={{
                  title: sectionItem.title,
                  items: sectionItem.items,
                }}
              />
            </AccordionContent>
          </Item>
        ))}
      </Accordion>
    </>
  );
}
